import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import ChangePassword from "../../components/dashboard/profilePartials/ChangePassword";
import Cart from "../../components/dashboard/Cart";
import { useState } from "react";
import { useGeneral } from "../../components/contexts/GeneralContext";

const CartPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <Wrapper component={<Cart />} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default CartPage;
